import React from 'react'
import styles from './UIGameEndReturnToStats.module.scss'
import {Button} from '../../../common/Button'
import {T} from '@colonist/ui'
import {useGameStore} from '../../../store/GameStoreContext'
import clsx from 'clsx'

interface UIGameEndReturnToStatsProps {
    text: 'strings:game.endGame.cornerButton.openStatsMobile' | 'strings:game.endGame.cornerButton.openStats'
    className?: string
}

export const UIGameEndReturnToStats = ({
    text,
    className,
}: UIGameEndReturnToStatsProps) => {
    const onClickStatsOrReplay = useGameStore((state) => state.gameEnd.endControls?.onClickStatsOrReplay)
    const isStatsVisible = useGameStore((state) => state.gameEnd.isVisible)

    if(!onClickStatsOrReplay) return null
    if(isStatsVisible) return null

    return <Button className={clsx(styles.button, className)} variant="dark" onClick={onClickStatsOrReplay}>
        <T id={text} />
    </Button>
}
